/**
 * The quiet "this belongs to your partner" tag on Today rows and test result
 * cards. It shows the partner's avatar and first name in the shared `Tag`,
 * and is one component so the appointment row, the medication row and the
 * result card cannot drift apart.
 */

import { Image } from "react-native";
import { Tag } from "@louise/moon-ui";
import { semanticColors } from "@louise/theme/tokens";

// Required, as the rows this replaces did: the asset lives with the app.
const avatarPlaceholder =
  require("@src/apps/moon/assets/images/avatar-placeholder.png") as number;

export function PartnerAvatarTag({ label }: { label: string }) {
  return (
    <Tag
      label={label}
      shape="pill"
      leading={
        <Image
          source={avatarPlaceholder}
          resizeMode="cover"
          style={{
            width: 18,
            height: 18,
            borderRadius: 9,
            borderWidth: 1,
            borderColor: semanticColors.border.glass,
          }}
        />
      }
      // The avatar sits close to the edge, the way the name sits close to it.
      style={{ paddingLeft: 4, maxWidth: 92 }}
      textStyle={{ flexShrink: 1 }}
    />
  );
}
